"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const mui_1 = require("tss-react/mui");
const uuid_1 = require("uuid");
const Alert_1 = __importDefault(require("@mui/material/Alert"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const TextField_1 = __importDefault(require("@mui/material/TextField"));
const DialogTitle_1 = __importDefault(require("@mui/material/DialogTitle"));
const DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
const DialogActions_1 = __importDefault(require("@mui/material/DialogActions"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const dataset_shares_1 = require("companion-app-components/flux/dataset-shares");
const rootUiActions_1 = require("companion-app-components/flux/root-ui/rootUiActions");
const core_1 = require("companion-app-components/utils/core");
const accountGroupsSelectors_1 = require("companion-app-components/flux/account-groups/accountGroupsSelectors");
const auth_1 = require("companion-app-components/flux/auth");
const entitlementsUtils_1 = require("companion-app-components/flux/entitlements/entitlementsUtils");
const utils_1 = require("containers/App/Header/ProfileMenu/utils");
const utils_2 = require("containers/ProfilePage/utils");
const AccountGroupsShare_1 = __importDefault(require("components/AccountGroupsShare"));
const AccessTypes_1 = __importDefault(require("./AccessTypes"));
const actions_1 = require("./actions");
const utils_3 = require("./components/utils");
const styles_1 = require("./styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const ShareFinancesDialog = ({ name, id, entitlements }) => {
    var _a, _b;
    const accountGroups = (0, react_redux_1.useSelector)(accountGroupsSelectors_1.getAccountGroups);
    const currentDatasetId = (0, react_redux_1.useSelector)(auth_1.authSelectors.getDatasetId);
    const sharedWith = (_b = (_a = (0, react_redux_1.useSelector)((state) => dataset_shares_1.datasetSharesSelectors.getSharesByDatasetId(state, id))) === null || _a === void 0 ? void 0 : _a.toList()) !== null && _b !== void 0 ? _b : [];
    const actualSharedWithCount = sharedWith.reduce((count, sharing) => {
        const hasExpiredInvite = (0, utils_2.checkIfInviteExpired)(sharing === null || sharing === void 0 ? void 0 : sharing.lastInviteSent);
        if ((sharing === null || sharing === void 0 ? void 0 : sharing.state) === dataset_shares_1.datasetSharesTypes.DATASET_SHARING_STATES.ABANDONED) {
            return count;
        }
        if ((sharing === null || sharing === void 0 ? void 0 : sharing.state) === dataset_shares_1.datasetSharesTypes.DATASET_SHARING_STATES.INVITED && hasExpiredInvite) {
            return count;
        }
        return count + 1;
    }, 0);
    const isCFOUser = (0, entitlementsUtils_1.hasCFOEntitlementForDataset)(entitlements);
    const [accountGroupsState, setAccountGroupsState] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        var _a;
        const accountGroupsWithAccess = (_a = accountGroups === null || accountGroups === void 0 ? void 0 : accountGroups.map((accountGroup) => (Object.assign(Object.assign({}, accountGroup.toJS()), { permission: 'NONE' })))) !== null && _a !== void 0 ? _a : [];
        setAccountGroupsState(accountGroupsWithAccess);
    }, [accountGroups]);
    const [firstName, setFirstName] = (0, react_1.useState)('');
    const [lastName, setLastName] = (0, react_1.useState)('');
    const [email, setEmail] = (0, react_1.useState)('');
    const [fullAccess, setFullAccess] = (0, react_1.useState)(true);
    const dispatch = (0, react_redux_1.useDispatch)();
    const { classes } = useStyles();
    const handleClose = () => {
        dispatch((0, rootUiActions_1.removeDialog)(actions_1.DIALOG_TYPE_SHARE_FINANCES));
    };
    const handleInvite = () => {
        const write = accountGroupsState
            .filter((accountGroup) => accountGroup.permission === 'WRITE')
            .map((accountGroup) => accountGroup.id);
        const read = accountGroupsState
            .filter((accountGroup) => accountGroup.permission === 'READ')
            .map((accountGroup) => accountGroup.id);
        const itemAccessControl = (0, utils_3.getItemAccessControl)(isCFOUser, fullAccess, read, write);
        const createPayload = dataset_shares_1.datasetSharesTypes.mkDatasetShare({
            clientId: (0, uuid_1.v4)(),
            datasetId: id,
            granteeFirstName: firstName,
            granteeLastName: lastName,
            granteeEmail: email,
            state: dataset_shares_1.datasetSharesTypes.DATASET_SHARING_STATES.INVITED,
            itemAccessControl,
        });
        dispatch(dataset_shares_1.datasetSharesActions.createDatasetShare(createPayload));
        core_1.tracker.track(core_1.tracker.events.datasetSharing, Object.assign({ property: 'inviteClicked' }, (isCFOUser && Object.assign(Object.assign({}, (0, utils_3.getCFOEntityAccessTrackingProps)(fullAccess, accountGroupsState.length, read, write)), { total_shared: actualSharedWithCount }))));
        handleClose();
    };
    const hasAtLeast1Entity = fullAccess || (!fullAccess && accountGroupsState.some(({ permission }) => permission !== 'NONE'));
    const inviteEnabled = firstName.trim() && lastName.trim() && email.trim() && (0, utils_1.isEmail)(email) && hasAtLeast1Entity;
    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    };
    const handleEmailKeyPress = (e) => {
        if (e.key === 'Enter' && inviteEnabled) {
            handleInvite();
        }
    };
    const handleAccessChange = (groupId, selectedAccess) => {
        const updated = accountGroupsState.map((accountGroup) => accountGroup.id === groupId ? Object.assign(Object.assign({}, accountGroup), { permission: selectedAccess }) : accountGroup);
        setAccountGroupsState(updated);
    };
    const handleFullAccessChange = (event) => {
        setFullAccess(event.target.value === 'true');
    };
    return (<Dialog_1.default open>
      <DialogTitle_1.default className={classes.dialogTitleWrapper}>
        <Typography_1.default variant="h6" className={classes.title}>
          Share finances
        </Typography_1.default>
        <Typography_1.default variant="body2" className={classes.textTertiary}>
          Enter details of the Quicken member who will share your financial data.
        </Typography_1.default>
      </DialogTitle_1.default>
      <IconButton_1.default aria-label="close" onClick={handleClose} className={classes.closeButton}>
        <Close_1.default fontSize="small"/>
      </IconButton_1.default>
      <DialogContent_1.default>
        <Typography_1.default variant="h5" className={classes.weight400}>
          {name}
        </Typography_1.default>
        <Typography_1.default gutterBottom variant="caption" className={classes.textTertiary}>
          Sharing with Quicken member
        </Typography_1.default>
        <div className={classes.formWrapper}>
          <div>
            <Typography_1.default variant="caption">
              First Name
            </Typography_1.default>
            <TextField_1.default variant="outlined" fullWidth size="small" value={firstName} onChange={(e) => setFirstName(e.target.value)}/>
          </div>
          <div>
            <Typography_1.default variant="caption">
              Last Name
            </Typography_1.default>
            <TextField_1.default variant="outlined" fullWidth size="small" value={lastName} onChange={(e) => setLastName(e.target.value)}/>
          </div>
        </div>
        <div>
          <Typography_1.default variant="caption">
            Email
          </Typography_1.default>
          <TextField_1.default variant="outlined" fullWidth size="small" value={email} onChange={handleEmailChange} onKeyPress={handleEmailKeyPress}/>
        </div>
        {isCFOUser &&
            <AccessTypes_1.default fullAccess={fullAccess} handleFullAccessChange={handleFullAccessChange} accountGroups={accountGroupsState}/>}
        {!isCFOUser &&
            <Alert_1.default icon={false} className={classes.alert}>
            By sharing your data, the invited member will have access to view and modify all your accounts, transactions, and other details.
          </Alert_1.default>}
        {!fullAccess && currentDatasetId === id &&
            <AccountGroupsShare_1.default accountGroups={accountGroupsState} onAccessLevelChange={handleAccessChange}/>}
      </DialogContent_1.default>
      <DialogActions_1.default className={classes.dialogAction}>
        <Button_1.default onClick={handleClose} variant="outlined" size="small">
          Cancel
        </Button_1.default>
        <Button_1.default variant="contained" size="small" disabled={!inviteEnabled} onClick={handleInvite} sx={{ backgroundColor: 'action.surface' }}>
          INVITE
        </Button_1.default>
      </DialogActions_1.default>
    </Dialog_1.default>);
};
exports.default = ShareFinancesDialog;
